<template>
  <span>
    <AttendeesMod />
    <Footer :window="window" />
  </span>
</template>

<script>
import AttendeesMod from "@/components/attendees/AttendeesModList";
import Footer from "@/components/layout/Footer";

export default {
  components: {
    AttendeesMod,
    Footer
  },
  data() {
    return {
      window: {
        width: window.innerWidth
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/page/AttendeesMod.vue